import { render, staticRenderFns } from "./manageAccessForm.vue?vue&type=template&id=2513b329"
import script from "./manageAccessForm.vue?vue&type=script&lang=js"
export * from "./manageAccessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports